module.exports = __webpack_public_path__ + "img/card_bg2.d6511ece.svg";